const data = {
  title: "Floor 4-8",
  musicTrack: "MUSIC_WORLD4",
  theme: "GRAY",
  tilesWidth: 12,
  tilesHeight: 12,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 5,
      y: 2
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 7,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 11,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 1,
      y: 7,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 7,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 1,
      y: 11,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 4,
      y: 10,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 5,
      y: 10,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 10,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 8,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 10,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 12,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 12,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 13,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 11,
      y: 13,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 13,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 11,
      y: 12,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 12,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 2,
      y: 12,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 1,
      y: 12,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 13,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 1,
      y: 13,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 2,
      y: 13,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 1,
      y: 10,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 1,
      y: 9,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 10,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 9,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 1,
      y: 8,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 1,
      y: 1,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 1,
      y: 2,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 2,
      y: 1,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 1,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 1,
      y: 6,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 1,
      y: 5,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 6,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 4,
      y: 13,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 4,
      y: 12,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 5,
      y: 12,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 5,
      y: 13,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 13,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 12,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 12,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 13,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 8,
      y: 13,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 8,
      y: 12,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 8,
      y: 9,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 8,
      y: 10,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 10,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 6,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 5,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 4,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 11,
      y: 4,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 1,
      y: 3,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 4,
      y: 1,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 4,
      y: 3,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 3,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 5,
      y: 3,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 1,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 5,
      y: 1,
      isRaised: true
    },
    {
      type: "CHIP",
      x: 11,
      y: 2
    },
    {
      type: "SWITCH_WALL",
      x: 12,
      y: 12,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 12,
      y: 13,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 8,
      y: 7,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 8,
      y: 6,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 12,
      y: 11,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 11,
      y: 10,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 12,
      y: 8,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 12,
      y: 7,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 3,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 8,
      y: 1,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 12,
      y: 4,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 12,
      y: 5,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 12,
      y: 6,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 4,
      y: 2,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 2,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 2,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 8,
      y: 3,
      isRaised: true
    },
    {
      type: "WATER_PICKUP",
      x: 8,
      y: 2
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 2,
      isRaised: false
    },
    {
      type: "SWITCH",
      x: 11,
      y: 2
    },
    {
      type: "WATER",
      x: 10,
      y: 3
    },
    {
      type: "WATER",
      x: 10,
      y: 2
    },
    {
      type: "WATER",
      x: 10,
      y: 1
    },
    {
      type: "WATER",
      x: 11,
      y: 1
    },
    {
      type: "WATER",
      x: 12,
      y: 1
    },
    {
      type: "WATER",
      x: 12,
      y: 3
    },
    {
      type: "WATER",
      x: 12,
      y: 2
    },
    {
      type: "WATER",
      x: 11,
      y: 3
    },
    {
      type: "ENEMY_SPAWN",
      x: 2,
      y: 11,
      enemyType: "ROAMING_ENEMY"
    },
    {
      type: "WATER",
      x: 4,
      y: 7
    },
    {
      type: "WATER",
      x: 4,
      y: 8
    },
    {
      type: "WATER",
      x: 4,
      y: 9
    },
    {
      type: "WATER",
      x: 5,
      y: 9
    },
    {
      type: "WATER",
      x: 6,
      y: 9
    },
    {
      type: "WATER",
      x: 6,
      y: 7
    },
    {
      type: "WATER",
      x: 5,
      y: 7
    },
    {
      type: "WATER",
      x: 6,
      y: 8
    },
    {
      type: "SWITCH",
      x: 5,
      y: 8
    },
    {
      type: "SWITCH_WALL",
      x: 2,
      y: 3,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 4,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 4,
      y: 4,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 5,
      y: 4,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 4,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 8,
      y: 4,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 6,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 5,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 7,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 8,
      isRaised: false
    },
    {
      type: "CLOWN_DEFENSE_PICKUP",
      x: 11,
      y: 5
    },
    {
      type: "SWITCH_WALL",
      x: 2,
      y: 7,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 8,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 2,
      y: 9,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 2,
      y: 10,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 11,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 4,
      y: 11,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 11,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 11,
      isRaised: false
    },
    {
      type: "CHIP",
      x: 5,
      y: 5
    },
    {
      type: "CHIP",
      x: 8,
      y: 5
    },
    {
      type: "CHIP",
      x: 8,
      y: 8
    },
    {
      type: "CHIP",
      x: 2,
      y: 8
    },
    {
      type: "CHIP",
      x: 11,
      y: 8
    },
    {
      type: "SWITCH_WALL",
      x: 12,
      y: 10,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 2,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 3,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 3,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 1,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 1,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 4,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 7,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 8,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 9,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 5,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 6,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 5,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 4,
      y: 5,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 5,
      y: 6,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 6,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 4,
      y: 6,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 5,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 1,
      y: 4,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 2,
      y: 4,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 4,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 9,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 10,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 11,
      isRaised: false
    },
    {
      type: "TELEPORT",
      x: 11,
      y: 8
    },
    {
      type: "TELEPORT",
      x: 2,
      y: 5
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 9,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 11,
      y: 9,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 12,
      y: 9,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 11,
      y: 6,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 11,
      y: 7,
      isRaised: false
    },
    {
      type: "SWITCH_WALL",
      x: 2,
      y: 6,
      isRaised: false
    },
    {
      type: "ENEMY_SPAWN",
      x: 5,
      y: 11,
      enemyType: "ROAMING_ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 8,
      y: 11,
      enemyType: "ROAMING_ENEMY"
    },
    {
      type: "CHIP",
      x: 11,
      y: 11
    }
  ]
};

export default data;
